window.addEventListener("load", (event) => {
    const body = document.body;
    let videoModals = Array.from(document.getElementsByClassName('modal-content-container-js'));

    if (videoModals.length !== 0) {
        videoModals.forEach(videoModal => {
            let videoSrc = null;
            let modalButton = videoModal.querySelector(".video-btn-modal-js");
            let modalContent = videoModal.querySelector(".video-modal-content-js");
            
            if (modalButton != null) {

                videoSrc = modalButton.dataset.src;
        
                if (modalContent != null) {
                    modalContent.addEventListener('shown.bs.modal', () => {
                        modalContent.querySelector('.embed-responsive-item-js').src = videoSrc.replace('/watch?v=', '/embed/');
                    });
        
                    modalContent.addEventListener('hide.bs.modal', () => {
                        modalContent.querySelector('.embed-responsive-item-js').src = videoSrc.replace('/watch?v=', '/embed/');
                    });

                    modalContent.parentNode.removeChild(modalContent);
                    body.appendChild(modalContent);
                }
            }
        });
    }
});
//# sourceMappingURL=text-and-image.js.map
